import { isEditableElement } from './pouchColorHotkeys';

/** レイヤー用 Alt/Option ショートカットのキー判定 */

export function getLayerModifierKeyLabel(): string {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  return isMac ? '⌥' : 'Alt';
}

export function isLayerSwitchNumberKey(e: KeyboardEvent): number | null {
  const num = parseInt(e.key, 10);
  if (num >= 1 && num <= 9) return num;
  return null;
}

export function isLayerPrevNextKey(e: KeyboardEvent): 'prev' | 'next' | null {
  if (e.key === 'ArrowLeft') return 'prev';
  if (e.key === 'ArrowRight') return 'next';
  return null;
}

export function isLayerAddKey(e: KeyboardEvent): boolean {
  return (
    e.key === '+' ||
    e.key === '=' ||
    e.code === 'Equal' ||
    e.code === 'NumpadAdd'
  );
}

export function isLayerRemoveKey(e: KeyboardEvent): boolean {
  return (
    e.key === '-' ||
    e.key === '_' ||
    e.code === 'Minus' ||
    e.code === 'NumpadSubtract'
  );
}

export function isLayerShortcutChord(e: KeyboardEvent): boolean {
  return e.altKey && !e.ctrlKey && !e.metaKey;
}

/** 計算エリアの新規パウチ keydown より先にレイヤー操作へ譲るか */
export function calcKeydownShouldYieldToLayerShortcut(
  e: KeyboardEvent,
  layerCount: number
): boolean {
  if (layerCount < 1 || !isLayerShortcutChord(e)) return false;
  if ((window as Window & { isIMEComposing?: boolean }).isIMEComposing) return false;

  const el = document.activeElement;
  const inLayerNameInput =
    el instanceof HTMLElement && !!el.closest('.sheet-layer-calc-item-input');
  if (isEditableElement(el) && !inLayerNameInput) return false;

  if (isLayerSwitchNumberKey(e) != null) return true;
  if (isLayerPrevNextKey(e) != null && layerCount > 1) return true;
  if (isLayerAddKey(e)) return true;
  if (isLayerRemoveKey(e) && layerCount > 1) return true;
  return false;
}
